export const buttonRowFront = (buttonsData, buttonrowDesign) => {

    var buttonArray = buttonsData.split(";").map(function(x) { return x.replace("}", "").split("{") });
    let buttonRow = [];
    buttonArray.forEach(function(item) {
        let icon = "arrow_forward";
        if (item[1].includes("://")) {
            icon = "open_in_new"
        }
        let button = `
            <div>
                <a class="buttonrow__button" href="${item[1]}" rel="noopener noreferrer">
                    <span class="buttonrow__button__text">${item[0]}</span>
                    <span class="material-icons-outlined buttonrow__button__icon">${icon}</span>
                </a>
            </div>`
        buttonRow.push(button);
    });
    buttonRow = buttonRow.join("");

    return `
        <section id="module__buttonrow" class="${buttonrowDesign}">
            <div class="container p-md-0">
                <div class="buttonrow p-0 justify-content-md-center" >
                    ${buttonRow}
                </div>
            </div>
        </section>`;
}
